export default __webpack_public_path__ + "static/media/fail.51f465ca.svg";